<template>
	<v-btn
		dark
		depressed
		color="#5C8DF5"
		v-bind="$attrs"
		v-on="$listeners"
		class="primary-button"
		:class="{ 'no-padding': noPadding }"
		style="text-transform: none !important"
	>
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'PrimaryButton',
	props: {
		noPadding: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.primary-button {
	border-color: #5d5cfc !important;
	background-color: #5d5cfc !important;

	&,
	&.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg {
		background-color: #5d5cfc !important;
		border-color: #5d5cfc !important;

		&:disabled {
			opacity: 0.5;
		}
	}

	&.no-padding {
		padding: 0px !important;
	}
}
</style>
